export const regionData = [
  {
    "label":"Pheonix-label",
    "value":"Pheonic-value"
  },
  {
    "label":"Reochester-label",
    "value":"Reochester-value"
  }
]

export const campusData = [
  {
    "label":"Campus1",
    "value":"Campus1"
  },
  {
    "label":"Campus1",
    "value":"Campus1"
  }
]

export const facilityData = [
  {
    "label":"Facility1",
    "value":"Facility1"
  },
  {
    "label":"Facility1",
    "value":"Facility2"
  }
]

export const locationData = [
  {
    "label":"locationLabel1",
    "value":"locationValue1"
  },
  {
    "label":"locationLabel2",
    "value":"locationValue2"
  }
]

export const functionalAreasData = [
  {
    "label":"functionalAreasLabel1",
    "value":"functionalAreasValue1"
  },
  {
    "label":"functionalAreasLabel2",
    "value":"functionalAreasValue2"
  }
]
